import React, { useEffect, useState } from 'react'
import { Typography, Switch, IconButton, Menu, MenuItem, Tooltip } from '@material-ui/core';
import { Menu as MenuIcon } from '@material-ui/icons';
import { IoIosInformationCircle } from 'react-icons/io'

import TableCustom from '../../../../Components/Table';
import ModalConfirmacao from '../../../../Components/ModalConfirmacao';

import { useStyles } from './styles';
import { formataCnpj, formataNit } from '../../../../Utils/utils';
import { atualizarRelacaoPrevidenciaria } from '../../../../Store/Actions/API/relacoesPrevidenciariasActions';

export default function RelacaoListItem({ relacao, planoLimitado, index, forcarReload = () => {}, 
onClicaRevisarRetencoes, onClicaMaisDetalhes, onClicaEditar, cpf }) {

    const classes = useStyles();
    const [relacaoListar, setRelacaoListar] = useState([])
    const [isLoadingAlterar, setLoadingAlterar] = useState(false);
    
    const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);

    useEffect(() => {
        setRelacaoListar([{ ...relacao }]);
    }, [relacao])

    const confirmaAlterar = async () => {
        await alterarEntidadeBeneficiente(!relacaoListar[0].entidadeBeneficente)
    }

    const cancelaAlterar = () => {
        if(!isLoadingAlterar){
            setOpenModalConfirmacao(false);
        }
    }

    const alterarEntidadeBeneficiente = async (value) => {
        setLoadingAlterar(true);

        let relacaoTmp = Object.assign({}, relacaoListar[0]);
        relacaoTmp.entidadeBeneficente = value;

        let response = await atualizarRelacaoPrevidenciaria({
            cpf,
            entidadeBeneficente: relacaoTmp.entidadeBeneficente,
            cnpjEmpregador: relacaoTmp.cnpjEmpregador,
            origemVinculo: relacaoTmp.origemVinculo,
            id: relacaoTmp.id
        });

        if (response.sucesso) {
            setRelacaoListar([{ ...relacaoTmp }]);
            forcarReload();
        }
        
        setLoadingAlterar(false);
        setOpenModalConfirmacao(false);
    }

    const columns = [
        {
            title: "Seq.",
            dataIndex: "sequencia",
            key: "sequencia",
            align: "center",
            width: 30,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value ?? '-'}</p>,
        },
        {
            title: "NIT",
            dataIndex: "nit",
            key: "nit",
            align: "left",
            width: 120,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value ? formataNit(value) : '-'}</p>,
        },
        {
            title: "Código Empregador",
            dataIndex: "codigoEmpregador",
            key: "codigoEmpregador",
            align: "left",
            width: 155,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value ? formataCnpj(value) : '-'}</p>,
        },
        {
            title: "CNPJ Empregador",
            dataIndex: "cnpjEmpregador",
            key: "cnpjEmpregador",
            align: "left",
            width: 145,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value ? formataCnpj(value) : '-'}</p>,
        },
        {
            title: "Tipo Filiado no Vínculo",
            dataIndex: "tipoFiliadoVinculo",
            key: "tipoFiliadoVinculo",
            align: "center",
            width: 165,
            render: (value, row) => <p style={{ fontSize: 13 }}>{value ?? ''}</p>,
        },
        {
            title: "Cooperado",
            dataIndex: "cooperado",
            key: "cooperado",
            align: "center",
            render: (value, row) => <p style={{ fontSize: 13 }}>{value ? 'Sim' : 'Não'}</p>,
        },
        {
            title: "Entidade Beneficente",
            dataIndex: "entidadeBeneficente",
            key: "entidadeBeneficente",
            align: "center",
            render: (value, row) => <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                <Typography style={{ fontSize: 13, paddingTop: 3, paddingRight: 3, opacity: isLoadingAlterar ? 0.5 : 1 }}>Não</Typography>
                <Switch disabled={isLoadingAlterar} size={'small'} onChange={(e) => setOpenModalConfirmacao(true)} className={classes.switch} checked={value} />
                <Typography style={{ fontSize: 13, paddingTop: 3, paddingLeft: 2, opacity: isLoadingAlterar ? 0.5 : 1 }}>Sim</Typography>
            </div>
        },
        {
            title: "Ações",
            dataIndex: "acoes",
            key: "acoes",
            align: "center",
            headerRender: (title) => <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ width: 145 }}>

                </div>
                <Typography style={{ fontSize: 12, paddingTop: 3, paddingRight: 3, fontWeight: 700 }}>{title}</Typography>
            </div>,
            render: () => <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ display: 'flex', width: 135 }}>

                    {!planoLimitado ? ((relacao.pendenteConfirmacao) && <Tooltip title={'Clique para revisar as retenções'} arrow placement='left'>
                        <div className={classes.alert} onClick={() => onClicaRevisarRetencoes(relacao)}>
                            <div style={{ width: 22, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <IoIosInformationCircle size={12} color='#FFB626' />
                            </div>
                            <div style={{ paddingTop: 2 }}>
                                <Typography style={{ fontSize: 10, userSelect: 'none' }}>Pendente de revisão</Typography>
                            </div>
                        </div>
                    </Tooltip>) : null}
                </div>
                <div style={{ paddingLeft: 12 }}>
                    <MenuCell
                        onClicaMaisDetalhes={() => onClicaMaisDetalhes(relacao)}
                        onClicaRevisarRetencoes={() => onClicaRevisarRetencoes(relacao)}
                        onClicaEditar={() => onClicaEditar(relacao)}
                    />
                </div>
                <div style={{ width: 10 }} />
            </div>,
        }
    ];

    const propsTable = {
        columns,
        data: relacaoListar,
        heightBody: "140px",
        minHeightBody: "90px",
        removeHeaderBackground: true,
        marginTopPaper: index === 0 ? 0 : 20,
        marginBorder: true,
        usarMarginBottomContainer: true,
        width: '98%',
        elevationPaper: 4,
        optionsToolbar: {
            info: (
                <div className={classes.header}>
                    <div className={classes.col1}>
                        <div style={{ paddingLeft: 5, paddingBottom: 2 }}>
                            <Typography className={classes.headerOrigem}>Origem do Vínculo:</Typography>
                        </div>
                        <div>
                            <Typography className={classes.headerEmpresa}>{relacao.origemVinculo || ''}</Typography>
                        </div>
                    </div>
                </div>
            ),
        },
    };

    return (
        <>
            {openModalConfirmacao && <ModalConfirmacao
                open={openModalConfirmacao}
                titulo={'Atenção'}
                onConfirma={confirmaAlterar}
                isLoading={isLoadingAlterar}
                onCancela={cancelaAlterar}
                confirmarText={'Confirmar'}
                textoComponent={<span>
                    Confirmar a alteração da condição de entidade beneficente?
                </span>}
            />}
            <TableCustom {...propsTable} />
        </>
    )
}

const MenuCell = ({ onClicaMaisDetalhes = () => { }, onClicaRevisarRetencoes = () => { }, onClicaEditar = () => { } }) => {

    const [localEl, setLocalEl] = useState(null);

    return (
        <>
            <Menu
                id="menu-opcoes"
                anchorEl={localEl}
                keepMounted={true}
                open={Boolean(localEl)}
                onClose={() => setLocalEl(null)}
                getContentAnchorEl={null}
                elevation={2}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <MenuItem style={{ fontSize: 14 }} onClick={() => { setLocalEl(null); onClicaRevisarRetencoes(); }}>Revisar retenções</MenuItem>
                <MenuItem style={{ fontSize: 14 }} onClick={() => { setLocalEl(null); onClicaEditar(); }}>Editar</MenuItem>
                <MenuItem style={{ fontSize: 14 }} onClick={() => { setLocalEl(null); onClicaMaisDetalhes(); }}>Mais detalhes</MenuItem>
            </Menu>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                <IconButton onClick={(event) => setLocalEl(event.currentTarget)} size='small'>
                    <MenuIcon />
                </IconButton>
            </div>
        </>
    )
}